export default __webpack_public_path__ + "static/media/man-giving-business-presentation-using-futuristic-digital-pen.dd52b5cc.png";